<!--
 * @Author: 四川华西绿舍建材有限公司
 * @Date: 2023-05-10 14:49:18
 * @LastEditors: hexy
 * @LastEditTime: 2023-05-11 15:17:06
 * @Description: 月报单价确认-生成列表
 * @FilePath: \ICPSxin\src\views\platform\ICPS\internetSales\mouthReportRecordList.vue
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main>
        <div class="header_right">
          <el-button class="bottom_all_two" @click="goBack">返 回</el-button>
        </div>
        <div class="card" style="margin-top: 30px">
          <div>
            <div style="margin: 10px 50px; font-size: 16px; color: darkgray">
              <span style="margin-left: 15px">工程名字：{{ params.engineeringName }}</span>
              <span style="margin-left: 15px">上次截至时间：{{ params.lastDueTime }}</span>
              <span style="margin-left: 15px">本次截至时间：{{ params.currentDueTime }}</span>
              <span style="margin-left: 15px"><el-button size="mini" class="bottom_all_two" @click="updateData">更 新</el-button></span>
              <span style="margin-left: 15px"><el-button size="mini" class="bottom_all_two" @click="lookChangePrice">查看调价</el-button></span>
              <span style="margin-left: 15px"><el-button size="mini" class="bottom_all_two" @click="priceMaintenanceDialog = true">查看信息价</el-button></span>
            </div>
          </div>
          <div style="margin-bottom: 10px">
            <div style="margin-right: 20px; display: flex; align-items: center; justify-content: end">
              <span>历史版本:</span>
              <el-select v-model="historyName" placeholder="请选择">
                <el-option v-for="item in historyList" :key="item.time" :label="item.time" :value="item.time" @click.native="selectHistory(item)"> </el-option>
              </el-select>
            </div>
          </div>
          <div v-loading="tableLoading" class="card_info" :style="style">
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="tableData" tooltip-effect="dark">
              <el-table-column align="center" label="开始时间" prop="startTime"></el-table-column>
              <el-table-column align="center" label="截止时间" min-width="230" prop="endTime"></el-table-column>
              <el-table-column align="center" label="调价类型" prop="adjustPriceType">
                <template slot-scope="scope">
                  <span>{{ adjustPriceTypeList | fromatTable(scope.row.adjustPriceType, "name", "id") }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="对应调价" prop="adjustEffectiveTimeTime">
                <template slot-scope="scope">
                  <span>{{ scope.row.adjustEffectiveTimeTime ? scope.row.adjustEffectiveTimeTime + "生效" : "未维护" }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="状态" prop>
                <template slot-scope="scope">
                  <span>{{ mouthReportStatusList | fromatTable(scope.row.generateStatus, "name", "id") }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-link v-if="scope.row.generateStatus == 0" type="success" :disabled="params.sureStatus == 2 || params.sureStatus == 3" :underline="false" @click="toConfirm(scope.row, scope.$index)">生成月报价</el-link>
                  <el-link v-else type="success" :disabled="params.sureStatus == 2 || params.sureStatus == 3" :underline="false" @click="toConfirm(scope.row)">查看</el-link>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-main>
      <!-- <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination
            :current-page.sync="tableParam.page"
            :page-size="tableParam.pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]"
            layout="prev,pager,sizes,next,jumper"
            :total="total"
            @size-change="sizeChange"
            @current-change="gettableData()"
          ></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableData">刷新</el-button>
        </div>
      </div> -->
    </el-container>
    <informationPriceNumDialog
      ref="informationPriceNumDialog"
      :infoNumDialog.sync="infoNumDialog"
      :infoNumData.sync="infoNumData"
      @refInfoPriceDialog="queryInfoReadjustCostDetailFun"
      @closeInformationSetPriceDialog="(infoNumDialog = false), queryHisttoryList(false)"
    />
    <monthPriceDialog ref="monthPriceDialog" :showType="2" :monthPriceDialog.sync="monthPriceDialog" :monthPriceData.sync="monthPriceData" @closeMonthPriceDialog="(monthPriceDialog = false), queryHisttoryList(false)">
    </monthPriceDialog>
    <unmaintainedDialog :unmaintainedDialog.sync="unmaintainedDialog" :showType="2" :data="selectData" @closeUnmaintainedDialog="(unmaintainedDialog = false), queryHisttoryList(false)" />
    <priceMaintenanceDialog :priceMaintenanceDialog.sync="priceMaintenanceDialog" @closePriceMaintenanceDialog="priceMaintenanceDialog = false" />
    <diaLog1 :dialog="dialog1" :isLook="true" :low="low" @reset="reset"></diaLog1>
  </div>
</template>
  <script>
import mixin from "@/mixins/ICPSmixin.js";
import { queryPageByMonthRecord, updatePriceManage, getEngPriceAdjust, queryHisttoryList } from "@/api/internetSales/monthlyReportUnitRecord.js";
import informationPriceNumDialog from "./monthlyReportDialog/informationPriceNumDialog.vue";
import monthPriceDialog from "./monthlyReportDialog/monthPriceDialog.vue";
import unmaintainedDialog from "./monthlyReportDialog/unmaintainedDialog.vue";
import priceMaintenanceDialog from "./monthlyReportDialog/priceMaintenanceDialog.vue";
import { getUserInfo } from "@/utils/auth.js";
const diaLog1 = () => import("@/views/platform/ICPS/internetSales/dialog/engineeringControl1.vue");
export default {
  components: {
    informationPriceNumDialog,
    monthPriceDialog,
    unmaintainedDialog,
    priceMaintenanceDialog,
    diaLog1,
  },
  mixins: [mixin],
  data() {
    return {
      dialog1: false,
      low: {},
      priceMaintenanceDialog: false,
      // 月报价
      monthPriceData: {},
      monthPriceDialog: false,
      // 信息期数
      infoNumData: {},
      infoNumDialog: false,
      // 未维护
      selectData: {},
      unmaintainedDialog: false,
      UserInfo: "",
      params: {},
      parentParams: {},
      /*表格增删改查及下载接口*/
      queryPage: queryPageByMonthRecord,
      pagesType: 0,
      tableData: [],
      mouthReportStatusList: [
        { name: "未生成月报价", id: 0 },
        { name: "已生成月报价", id: 1 },
        { name: "待更新", id: 3 },
      ],
      adjustPriceTypeList: [
        { name: "产品价格", id: 1 },
        { name: "信息价格", id: 3 },
        { name: "协商价格", id: 2 },
        { name: "特殊产品", id: 4 },
        { name: "未维护", id: 5 },
      ],
      historyList: [],
      historyName: "",
    };
  },
  async created() {
    this.params = JSON.parse(this.$route.query.row);
    console.log('this.params',this.params)
    this.parentParams = JSON.parse(this.$route.query.parentRow);
    console.log('this.parentParams',this.parentParams)
    this.UserInfo = await getUserInfo();
    this.tableParam = { ...this.tableParam, cycleManageId: this.params.id };
    // this.gettableData();
    this.queryHisttoryList(true);
  },

  methods: {
    queryHisttoryList(type) {
      queryHisttoryList({ cycleManageId: this.params.id }).then(res => {
        if (res.code == 1001) {
          this.historyList = res.data;
          if (type) {
            this.tableData = res.data[0].adjustmentPriceManages;
            this.historyName = res.data[0].time;
          } else {
            res.data.forEach(item => {
              if (this.historyName == item.time) {
                this.tableData = item.adjustmentPriceManages;
              }
            });
          }
        }
      });
    },
    selectHistory(item) {
      this.tableData = item.adjustmentPriceManages;
      this.historyName = item.time;
    },
    lookChangePrice() {
      let _this = this;
      getEngPriceAdjust({ engId: _this.params.engineeringId }).then(res => {
        if (res.code == 1001) {
          _this.low = res.data;
          _this.low.id = _this.params.engineeringId;
          _this.dialog1 = true;
        }
      });
    },
    reset(key) {
      this[key] = false;
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableData();
    },
    //   去确认
    toConfirm(row, index) {
      if (index || index == 0) {
        let status = false; //判断是否可以去确认
        if (index == this.tableData.length - 1) {
          status = true;
        } else {
          status = this.tableData[index + 1].generateStatus == 0 ? false : true; //为了调试 true 和false 位置反
        }
        this.tableData.forEach((item, index2) => {
          if (index2 > index && item.generateStatus == 0) {
            status = false;
          }
        });
        if (!status) {
          this.$message.warning("请按照时间先后顺序进行确认！");
          return;
        }
      }
      if (row.adjustPriceType != 5) {
        // 产品价格\信息价格
        this.infoNumDialog = true;
        this.infoNumData = row;
      } else {
        this.$message.warning("请到工程调价维护对应生效时间的调价记录！");
        // 未维护
        // this.unmaintainedDialog = true;
        // this.selectData = row;
      }
      // this.$router.push({name:'monthlyReportList',params: {row:row}})
    },
    goBack() {
      this.$router.push({ name: "monthlyReportList", query: { row: JSON.stringify(this.parentParams) } });
    },
    updateData() {
      this.$confirm("是否确认更新?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      })
        .then(() => {
          updatePriceManage({ cycleManageId: this.params.id }).then(res => {
            if (res.code == 1001) {
              this.params.sureStatus = 0;
              this.$message.success("更新成功!");
              this.queryHisttoryList(true);
            }
          });
        })
        .catch(() => {});
    },
    queryInfoReadjustCostDetailFun() {},
  },
};
</script>
  
  <style lang="scss" scoped>
.styleA {
  overflow: auto;
  max-height: calc(85vh - 266px);
  padding-right: 10px;
}
.styleB {
  overflow: auto;
  max-height: calc(85vh - 366px);
  padding-right: 10px;
}
.saledialoginfo {
  padding: 20px 20px 0 0px;
  max-height: calc(85vh - 220px);
}
.el-input,
.el-select {
  width: 240px;
}
.top_link {
  color: #008000;
}
.top_link:hover {
  cursor: pointer;
  opacity: 0.7;
}
.table_link {
  margin-left: 10px;
  color: $bg_color;
}

.table_link:hover {
  opacity: 0.8;
}
.tabtop {
  width: 378px;
  display: flex;
  border: $bg_color 1px solid;
  border-radius: 4px;
  margin: 20px 20px 0 20px;
  > div {
    height: 40px;
    width: 190px;
    font-size: 16px;
    font-weight: 400;
    cursor: pointer;
    display: flex;
    align-items: center;
    .text {
      width: 188px;
      @include discen;
      line-height: 40px;
      color: $bg_color;
    }
    .active {
      width: 188px;
      @include discen;
      line-height: 40px;
      color: #ffffff;
      background: $bg_color;
      border-radius: 4px;
    }
    .hr {
      height: 20px;
      width: 2px;
      background: $bg_color;
    }
  }
}
.el-input,
.el-select {
  width: 227px;
}
.dialoginfo {
  padding: 0;
}
.form-title {
  font-size: 18px;
  margin: 10px 0;
}
</style>
  